import FeatureSectionFive, { FeatureSectionFiveProps } from './FeatureSectionFive'

export default FeatureSectionFive

export { FeatureSectionFive }
export type { FeatureSectionFiveProps }
